import { EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { getDateInFormat, getStartAndEndDates, } from "@domains/utils/reportDates";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
export var leadTabs = [
    { title: "All", eventKey: "0" },
    { title: "Created By Me", eventKey: "1" },
    { title: "Assigned To Me", eventKey: "2" },
    { title: "Primary Owner", eventKey: "6" },
    { title: "Assigned To Group", eventKey: "3" },
    { title: "Assigned By Me", eventKey: "4" },
    { title: "Joint", eventKey: "5" },
];
export var assignedToGroupKey = "3";
export var assignedByMeGroupKey = "4";
export var jointTabKey = "5";
export var meetingTypeLabel = {
    product: {
        productLabel: "Asset Class",
        categoryLabel: "Product",
        schemeLabel: "Instrument Name",
    },
    acquisition: {
        productLabel: "A/C Type",
        categoryLabel: "Product",
        schemeLabel: "Sub Category",
    },
    engagementService: {
        productLabel: "Product",
        categoryLabel: "Category",
        schemeLabel: "Sub Category",
    },
};
export var removeObjectValues = function (unfilteredObject, filterExpression) {
    var localObj = unfilteredObject;
    Object.keys(localObj).forEach(function (item) {
        if (filterExpression.test(item)) {
            delete localObj[item];
        }
    });
    return localObj;
};
export var removeTabs = function () {
    var tabsList = leadTabs;
    var loginType = loginDI.login.getIsRMPartnerFRM();
    if (loginType.isPartner) {
        tabsList = [
            { title: "All", eventKey: "0" },
            { title: "Created By Me", eventKey: "1" },
            { title: "Assigned To Me", eventKey: "2" },
        ];
    }
    return tabsList;
};
export var followupCountList = [
    {
        title: "1-3",
        value: "1-3",
        checked: false,
    },
    {
        title: "4-6",
        value: "4-6",
        checked: false,
    },
    {
        title: "7-9",
        value: "7-9",
        checked: false,
    },
    {
        title: ">9",
        value: "9",
        checked: false,
    },
];
export var expiryFilters = {
    1: {
        id: 1,
        name: "Today",
        parentFilter: EnumSalesFilter.expiryId,
        inputType: "dropdown",
        checked: true,
    },
    2: {
        id: 2,
        name: "This Week",
        parentFilter: EnumSalesFilter.expiryId,
        inputType: "dropdown",
        checked: true,
    },
    3: {
        id: 3,
        name: "This Month",
        parentFilter: EnumSalesFilter.expiryId,
        inputType: "dropdown",
        checked: true,
    },
    4: {
        id: 4,
        name: "Expired",
        parentFilter: EnumSalesFilter.expiryId,
        inputType: "dropdown",
        checked: true,
    },
};
export var dateRangeConstants = {
    1: "day",
    2: "isoWeek",
    3: "month",
};
export var getDateRangeForExpiredLeads = function (expiryId) {
    var finalFilterState = {
        ExpiryfromDate: "",
        ExpirytoDate: "",
    };
    if (expiryId) {
        var id = Number(expiryId);
        finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates(dateRangeConstants[id]).startDate, "YYYY/MM/DD");
        finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates(dateRangeConstants[id]).endDate, "YYYY/MM/DD");
    }
    return finalFilterState;
};
export var singleDigitToDoubleDigit = function (value) {
    if (value <= 0) {
        return "00";
    }
    else if (value >= 1 || value <= 9) {
        return "0" + value;
    }
    else
        return value;
};
